"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Links = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const framer_motion_1 = require("framer-motion");
const PanelLayout_1 = require("../MenuPanel/PanelLayout");
const MotionLink = (0, framer_motion_1.motion)(app_1.Link);
function Links({ links }) {
    return ((0, jsx_runtime_1.jsx)(PanelLayout_1.PanelLayout, { children: (0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: links.map((v) => ((0, jsx_runtime_1.jsx)(MotionLink, Object.assign({ whileHover: { x: 20 }, href: v.href }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span", as: "h1" }, { children: v.label })) }), v.label))) })) }));
}
exports.Links = Links;
